/* eslint-disable react/prop-types */
import { Flexbox, Form } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import { ANIMAL } from '@/lib/enums'
import categories from '@/services/api/categories'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

// import { Container } from './styles';

function AnimalForm({
 touched, setFieldValue, values, errors,
}) {
  const [breedList, setBreedList] = useState([])
  const { data: categoryList, loading: loadingCategories } = useAxiosRequest(categories.list)

  useEffect(() => {
    if (values.animalCategory) {
      setBreedList([])
      setFieldValue('animalBreed', '')
      categories.breedsByCategoryId(values.animalCategory).then(({ data }) => setBreedList(data))
    }
  }, [setFieldValue, values.animalCategory])

  return (
    <>
      <Flexbox.Column className="col-8 col-sm-12">
        <Form.Group className={`${touched?.animalName && errors?.animalName ? 'has-error' : ''}`}>
          <Form.Label htmlFor="animalName">Nome do pet <span className="text-error">*</span></Form.Label>
          <Form.ValidationField
            name="animalName"
            id="animalName"
            placeholder="Pet da Silva"
          />
          {
            touched?.animalName && errors?.animalName
              ? <Form.Hint className="text-error">{errors.animalName}</Form.Hint> : null
          }
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-4 col-sm-12">
        <Form.Group className={`${touched?.animalColor && errors?.animalColor ? 'has-error' : ''}`}>
          <Form.Label htmlFor="animalColor">Cor/caract. do pet <span className="text-error">*</span></Form.Label>
          <Form.ValidationField
            name="animalColor"
            id="animalColor"
            placeholder="Caramelo"
          />
          {
            touched?.animalColor && errors?.animalColor
              ? <Form.Hint className="text-error">{errors.animalColor}</Form.Hint> : null
          }
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-4 col-sm-12">
        <Form.Group className={`${touched?.animalSize && errors?.animalSize ? 'has-error' : ''}`}>
          <Form.Label htmlFor="animalSize">Tamanho do pet <span className="text-error">*</span></Form.Label>
          <Form.ValidationField name="animalSize">
            {
              ({ field }) => (
                <>
                  <Form.Select
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    id="animalSize"
                    placeholder="Tamanho do pet"
                  >
                    <option value="">Selecione</option>
                    {
                      Object.values(ANIMAL.size.enum).map((value) => (
                        <option
                          key={value}
                          value={value}
                        >{ANIMAL.size.t(value)}
                        </option>
                      ))
                    }
                  </Form.Select>
                  {
                    touched?.animalSize && errors?.animalSize
                      ? <Form.Hint className="text-error">{errors.animalSize}</Form.Hint> : null
                  }
                </>
              )
            }
          </Form.ValidationField>
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-4 col-sm-12">
        <Form.Group className={`${touched?.animalGender && errors?.animalGender ? 'has-error' : ''}`}>
          <Form.Label htmlFor="animalGender">Sexo do pet <span className="text-error">*</span></Form.Label>
          <Form.ValidationField name="animalGender">
            {
              ({ field }) => (
                <>
                  <Form.Select
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    id="animalGender"
                    placeholder="Tamanho do pet"
                  >
                    <option value="">Selecione</option>
                    {
                      Object.values(ANIMAL.gender.enum).map((value) => (
                        <option
                          key={value}
                          value={value}
                        >{ANIMAL.gender.t(value)}
                        </option>
                      ))
                    }
                  </Form.Select>
                  {
                    touched?.animalGender && errors?.animalGender
                      ? <Form.Hint className="text-error">{errors.animalGender}</Form.Hint> : null
                  }
                </>
              )
            }
          </Form.ValidationField>
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-4 col-sm-12">
        <Form.Group className={`${touched?.animalBornedAt && errors?.animalBornedAt ? 'has-error' : ''}`}>
          <Form.Label htmlFor="animalBornedAt">Nascimento</Form.Label>
          <Form.ValidationField
            name="animalBornedAt"
            id="animalBornedAt"
          >
            {
              ({ field }) => (
                <Form.DatePickerField
                  locale="pt-BR"
                  name="animalBornedAt"
                  placeholderText="DD/MM/AAAA"
                  onChange={(value) => setFieldValue('animalBornedAt', value)}
                  selected={field.value}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  className="form-input"
                />
              )
            }
          </Form.ValidationField>
          {
            touched?.animalBornedAt && errors?.animalBornedAt
              ? <Form.Hint className="text-error">{errors.animalBornedAt}</Form.Hint> : null
          }
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-4 col-sm-12">
        <Form.Group className={`${touched?.microchip && errors?.microchip ? 'has-error' : ''}`}>
          <Form.Label htmlFor="microchip">Microchip</Form.Label>
          <Form.ValidationField
            name="microchip"
            id="microchip"
            placeholder="Microchip"
          />

          {
            touched?.microchip && errors?.microchip
              ? <Form.Hint className="text-error">{errors.microchip}</Form.Hint> : null
          }
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-4 col-sm-12">
        <Form.Group className={`${touched?.animalCategory && errors?.animalCategory ? 'has-error' : ''}`}>
          <Form.Label htmlFor="animalCategory">Espécie <span className="text-error">*</span></Form.Label>
          <Form.ValidationField
            name="animalCategory"
            id="animalCategory"
          >
            {
              ({ field }) => (
                <>
                  <Form.Select
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    id="animalCategory"
                    placeholder="Espécie"
                    disabled={loadingCategories}
                  >
                    <option value="">Selecione</option>
                    {
                      (categoryList ?? []).map((category) => (
                        <option
                          key={category.id}
                          value={category.id}
                        >{category.description}
                        </option>
                      ))
                    }
                  </Form.Select>
                  {
                    touched?.animalCategory && errors?.animalCategory
                      ? <Form.Hint className="text-error">{errors.animalCategory}</Form.Hint> : null
                  }
                </>
              )
            }
          </Form.ValidationField>
          {
            touched?.animalBornedAt && errors?.animalBornedAt
              ? <Form.Hint className="text-error">{errors.animalBornedAt}</Form.Hint> : null
          }
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-4 col-sm-12">
        <Form.Group className={`${touched?.animalBreed && errors?.animalBreed ? 'has-error' : ''}`}>
          <Form.Label htmlFor="animalBreed">Raça <span className="text-error">*</span></Form.Label>
          <Form.ValidationField
            name="animalBreed"
            id="animalBreed"
          >
            {
              ({ field }) => (
                <>
                  <Form.Select
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    id="animalBreed"
                    placeholder="Espécie"
                    disabled={loadingCategories || !breedList.length}
                  >
                    <option value="">Selecione</option>
                    {
                      (breedList ?? []).map((breed) => (
                        <option
                          key={breed.id}
                          value={breed.id}
                        >{breed.description}
                        </option>
                      ))
                    }
                  </Form.Select>
                  {
                    touched?.animalBreed && errors?.animalBreed
                      ? <Form.Hint className="text-error">{errors.animalBreed}</Form.Hint> : null
                  }
                </>
              )
            }
          </Form.ValidationField>
          {
            touched?.animalBornedAt && errors?.animalBornedAt
              ? <Form.Hint className="text-error">{errors.animalBornedAt}</Form.Hint> : null
          }
        </Form.Group>
      </Flexbox.Column>
    </>
  )
}

AnimalForm.defaultProps = {
  values: PropTypes.objectOf(Object).isRequired,
  touched: PropTypes.objectOf(Object).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(Object).isRequired,
}

export default AnimalForm
